import React from 'react';
import * as Yup from 'yup';

export const RewardItemValidatorSchema = Yup.object().shape({
});